import script from "./PathoBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PathoBar.vue?vue&type=script&setup=true&lang=js"

import "./PathoBar.vue?vue&type=style&index=0&id=e5d8f45e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5d8f45e"]])

export default __exports__